<template>
  <div class="email">
    <div class="email-head">
      <el-tag effect="dark" size="small">邮件首页</el-tag>
      <el-input v-if="check !== 0" placeholder="请输入主题" v-model="input" size="small" style="width:300px;height:20px">
        <el-button @click="handleSearch" slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="emall-content">
       <ul>
        <li v-for="(item, index) in title" :key="index" :class="check === index ? 'active' : ''" @click="handleClick(index)">
          <img width="20" :src="check === index ? item.active : item.img" alt="">
          <div  style="width:60px">{{item.name}}</div> 
          <div style="width:40px;text-align:right" v-if="item.flag">
            {{item.count > 9999 ? 9999 : item.count}}<sup v-if="item.count > 9999 ">+</sup>
          </div>
          <div style="width:40px" v-else></div>
        </li>
       </ul>
       <div class="list">
        <div class="list-header" v-if="check !== 0 && flag">
          <h1>
            {{title[check].name}}
            <span v-if="check !== 0">（共{{total}}封 <span v-if="check===1"> &nbsp; &nbsp; 未读邮件 {{title[1].count}} 封</span> ）</span>
          </h1>
          <el-button type="danger" size="medium" @click="handleDelete" :loading="$refs.InBox ? $refs.InBox.loading : false">删除</el-button>
        </div>
        <div>
          <WriteEmail ref="InBox" v-if="check === 0" />
          <InBox :key="visible" ref="InBox" v-if="check !== 0" :check="check" :input="input" :flag.sync="flag" :total.sync="total"/>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
import InBox from './modules/InBox.vue'
import WriteEmail from './modules/WriteEmail.vue'
import { Email } from '@/api/email'
let timer
export default {
  name: 'email',
  components:{
    InBox,
    WriteEmail
  },
  data() {
    return {
      title:[
        {
          name: '写邮件',
          img:require('@/assets/img/email1-1.png'),
          active: require('@/assets/img/email1-2.png')
        },
        {
          name: '收件箱',
          count: 0,
          flag: true,
          img:require('@/assets/img/email2-1.png'),
          active: require('@/assets/img/email2-2.png')
        },
        {
          name: '已发送',
          img:require('@/assets/img/email3-1.png'),
          active: require('@/assets/img/email3-2.png')
        },
        {
          name: '草稿箱',
          count: 0,
          flag: true,
          img:require('@/assets/img/email4-1.png'),
          active: require('@/assets/img/email4-2.png')
        },
        {
          name: '废纸篓',
          flag: false,
          img:require('@/assets/img/email5-1.png'),
          active: require('@/assets/img/email5-2.png')
        }
      ],
      check:1,
      input: '',
      flag: true,
      total: 0,
      visible: true
    }
  },
  created() {
    this.init()
    timer = setInterval(() => {
      this.init()
    },10 * 1000)
  },
  beforeDestroy(){
    clearInterval(timer)
    timer = null
  },
  methods:{
    init(){
      Email.getCount(this,{query: this.check === 1 ? this.input : ''}).then(res => {
        this.title[1].count = res.data.notReadNum
        this.title[3].count = res.data.draftNum
      })
    },
    handleClick(index){
      this.check = index
      this.init()
      this.visible = false
      this.$nextTick(() => {
        this.visible = true
      })
    },
    handleSearch(){
      this.$refs.InBox.handleReset(true)
      this.$refs.InBox.visible = true
    },
    handleDelete(){
     this.$refs.InBox.delete()
    }
  }
}
</script>
<style lang="scss" scoped>
*{
  margin: 0;
  // padding: 0;
}
.email{
  background-color: #F5F8F9 !important;
  padding:0 20px !important;
}
.email-head{
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.emall-content{
  background-color: #F5F8F9 !important;
  border-top: 1px solid #E5E5E5;
  display: flex;
  justify-content: space-between;
  ul,li{
    list-style:none;
  }
  ul{
    width: 250px;
    background-color: #fff;
    height: 80vh;
    padding: 18px 13px 0;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #444446;
      font-size: 18px;
      padding: 5px 20px;
      margin: 8px 0;
      cursor: pointer;
      border: 1px solid transparent;
    }
    .active{
      background: rgba(33, 128, 209, .1);
      color: #2180D1;
      position: relative;
      &::after{
        display: block;
        content: '';
        width: 3px;
        height: 35px;
        background-color: #2180D1;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  .list{
    flex: 1;
    margin-left: 20px;
    background-color: #fff;
    padding: 20px;
    .list-header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      h1{
        font-size: 25px;
        font-weight: 700;
      }
    }
  }
}
</style>